import { Injectable } from '@angular/core';
import { TooltipComponent } from '@mapfre-design-library/src/public_api';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  private tooltips:  Map<string, TooltipComponent>;

  register(id: string, tooltip: TooltipComponent) {
    if(!this.tooltips){
      this.tooltips = new Map<string, TooltipComponent>()
    }
    
    this.tooltips.set(id, tooltip)
  }

  unregister(id: string) {
    this.tooltips.delete(id)
  }

  open(id: string){
    this.tooltips.forEach((tooltip, key) => {
      if(key !== id){
        tooltip.hide();
      }
    })
  }
}
